import React from "react";
import stateRegion from "../../state/state.region";
import { observer } from "mobx-react-lite";

const RegionComponent = observer(() => {
  const cnahgeRegion = (e) => {
    stateRegion.setParameters("region", JSON.parse(e.target.value).tag_country);
  };
  return (
    <select onChange={cnahgeRegion} className="select_container">
      <option defaultValue hidden>
        {stateRegion.region}
      </option>
      {stateRegion.collectionRegion.map((r) => (
        <option value={JSON.stringify(r)}>{r.tag_country}</option>
      ))}
    </select>
  );
});

export default RegionComponent;
